import { combineReducers } from "redux";
import host from "../features/admin/host/slice";

const HostData = combineReducers({
  host: host,
});

export default HostData;
